import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
	selector: 'model-form',
	template: `
		<form class="model-form compact" [formGroup]="form" (ngSubmit)="submitted.emit(form.value)">
			<section class="form-block">
				<ng-container modelField></ng-container>
			</section>
		</form>
	`,
	styles: []
})
export class ModelFormComponent implements OnInit {

	@Input() map: any[] = [];
	@Input() model: any;
	form: FormGroup;

	@Output() submitted: EventEmitter<any> = new EventEmitter<any>();

	constructor( private fb: FormBuilder ){ }

	ngOnInit(){ this.form = this.createGroup(); }

	createGroup(){
		const group = this.fb.group({});
		this.map.forEach( c => group.addControl( c.name, this.fb.control( '' ) ) );
		return group;
	}
}
